import React, { Fragment } from "react";
import { Row, Col, Label, Table } from "reactstrap";

import Spinner from "../../layout/Spinner";

const DisputeResultOrder = ({ order, loading }) => {
  // Styling
  const table_price = {
    textAlign: "right",
  };

  return (
    <Fragment>
      {" "}
      {order ? (
        <Fragment>
          {" "}
          {order.map((each, index) => {
            return (
              <Fragment key={index}>
                {" "}
                {/* Information 1 */}{" "}
                <Row
                  style={{
                    border: "0px solid",
                    margin: "1.5rem auto",
                  }}
                >
                  <Col
                    style={{
                      border: "0px solid",
                    }}
                  >
                    <Label for="order_id">
                      <strong> Order ID: </strong>{" "}
                    </Label>{" "}
                    & ensp; <span> {each.name} </span> <br />
                    <Label for="store_name">
                      <strong> Store Name: </strong>{" "}
                    </Label>{" "}
                    & ensp; <span> {each.store_name} </span>{" "}
                  </Col>{" "}
                </Row>{" "}
                {/* Information 2 */}{" "}
                <Row
                  style={{
                    border: "0px solid",
                    margin: "auto auto",
                    wordBreak: "break-all",
                  }}
                >
                  <Col
                    lg={6}
                    style={{
                      border: "0px solid",
                    }}
                  >
                    <h5> Customer Details </h5>{" "}
                    <Table borderless size="sm">
                      {" "}
                      {each.shipping_address ? (
                        <tbody>
                          <tr>
                            <td width="22%"> </td> <td width="78%"> </td>{" "}
                          </tr>{" "}
                          <tr>
                            <td> Email: </td> <td> {each.contact_email} </td>{" "}
                          </tr>{" "}
                          <tr>
                            <td> Phone: </td>{" "}
                            <td> {each.shipping_address.phone} </td>{" "}
                          </tr>{" "}
                          <tr>
                            <td> Name: </td>{" "}
                            <td> {each.shipping_address.name} </td>{" "}
                          </tr>{" "}
                          <tr>
                            <td> Address: </td>{" "}
                            <td>
                              {" "}
                              {each.shipping_address.address1.trim()}{" "}
                              {each.shipping_address.address2 &&
                                " " +
                                  each.shipping_address.address2.trim()}{" "}
                            </td>{" "}
                          </tr>{" "}
                          <tr>
                            <td> City: </td>{" "}
                            <td> {each.shipping_address.city} </td>{" "}
                          </tr>{" "}
                          <tr>
                            <td> Province: </td>{" "}
                            <td> {each.shipping_address.province} </td>{" "}
                          </tr>{" "}
                          <tr>
                            <td> Country: </td>{" "}
                            <td> {each.shipping_address.country} </td>{" "}
                          </tr>{" "}
                          <tr>
                            <td> Zip: </td>{" "}
                            <td> {each.shipping_address.zip} </td>{" "}
                          </tr>{" "}
                        </tbody>
                      ) : (
                        <tbody>
                          <tr>
                            <td width="22%"> </td> <td width="78%"> </td>{" "}
                          </tr>{" "}
                          <tr>
                            <td> Email: </td> <td> {each.contact_email} </td>{" "}
                          </tr>{" "}
                          <tr>
                            <td> Phone: </td> <td> N / A </td>{" "}
                          </tr>{" "}
                          <tr>
                            <td> Name: </td> <td> N / A </td>{" "}
                          </tr>{" "}
                          <tr>
                            <td> Address: </td> <td> N / A </td>{" "}
                          </tr>{" "}
                          <tr>
                            <td> City: </td> <td> N / A </td>{" "}
                          </tr>{" "}
                          <tr>
                            <td> Province: </td> <td> N / A </td>{" "}
                          </tr>{" "}
                          <tr>
                            <td> Country: </td> <td> N / A </td>{" "}
                          </tr>{" "}
                          <tr>
                            <td> Zip: </td> <td> N / A </td>{" "}
                          </tr>{" "}
                        </tbody>
                      )}{" "}
                    </Table>{" "}
                    <br />
                  </Col>{" "}
                  <Col
                    lg={6}
                    style={{
                      border: "0px solid",
                    }}
                  >
                    <h5> Transaction Details </h5>{" "}
                    <Table borderless size="sm">
                      <tbody>
                        <tr>
                          <td width="33%"> </td> <td width="67%"> </td>{" "}
                        </tr>{" "}
                        <tr>
                          <td> Transaction ID: </td>{" "}
                          <td> {each.transaction_id} </td>{" "}
                        </tr>{" "}
                        <tr>
                          <td> Payment Status: </td>{" "}
                          <td> {each.financial_status} </td>{" "}
                        </tr>{" "}
                        <tr>
                          <td> Date Ordered: </td>{" "}
                          <td>
                            {" "}
                            {each.created_at.slice(
                              0,
                              each.created_at.indexOf("T")
                            )}{" "}
                          </td>{" "}
                        </tr>{" "}
                        <tr>
                          <td> Tracking Number: </td>{" "}
                          <td>
                            {" "}
                            {each.fulfillments.map((each, index) => {
                              return (
                                <span key={index}>
                                  {" "}
                                  {each.tracking_number} <br />
                                </span>
                              );
                            })}{" "}
                          </td>{" "}
                        </tr>{" "}
                        <tr>
                          <td> Tracking URL: </td>{" "}
                          <td>
                            {" "}
                            {each.fulfillments.map((each, index) => {
                              const url = `https://t.17track.net/en#nums=${each.tracking_number}`;
                              return (
                                <span key={index}>
                                  <a
                                    role="button"
                                    className="btn btn-link p-0 m-0"
                                    href={url}
                                    target="_blank"
                                  >
                                    {url}{" "}
                                  </a>{" "}
                                  <br />
                                </span>
                              );
                            })}{" "}
                          </td>{" "}
                        </tr>{" "}
                      </tbody>{" "}
                    </Table>{" "}
                    <br />
                  </Col>{" "}
                </Row>{" "}
                {/* Information 3 */}{" "}
                <Row
                  style={{
                    border: "0px solid",
                    margin: "auto auto",
                  }}
                >
                  <Col
                    style={{
                      border: "0px solid",
                    }}
                  >
                    <h5> Order Item(s) </h5>{" "}
                    <Table
                      responsive
                      style={{
                        width: "99%",
                      }}
                    >
                      <thead>
                        <tr>
                          <th width="4%"> # </th>{" "}
                          <th width="21%"> Product Name </th>{" "}
                          <th width="20%"> SKU </th>{" "}
                          <th width="20%"> Variant Title </th>{" "}
                          <th width="5%"> Quantity </th>{" "}
                          <th width="10%" style={table_price}>
                            Price{" "}
                          </th>{" "}
                          <th width="10%" style={table_price}>
                            Discount{" "}
                          </th>{" "}
                          <th width="10%" style={table_price}>
                            Total{" "}
                          </th>{" "}
                        </tr>{" "}
                      </thead>{" "}
                      <tbody>
                        {" "}
                        {each.line_items.map((each, index) => {
                          return (
                            <tr key={index}>
                              <td> {index + 1}. </td> <td> {each.title} </td>{" "}
                              <td> {each.sku} </td>{" "}
                              <td> {each.variant_title} </td>{" "}
                              <td
                                style={{
                                  textAlign: "center",
                                }}
                              >
                                {each.quantity}{" "}
                              </td>{" "}
                              <td style={table_price}> {each.price} </td>{" "}
                              <td style={table_price}>
                                {" "}
                                {each.total_discount}{" "}
                              </td>{" "}
                              <td style={table_price}>
                                {" "}
                                {each.total_discount !== "0.00" ? (
                                  <span>
                                    <span
                                      style={{
                                        textDecoration: "line-through black",
                                      }}
                                    >
                                      {parseFloat(
                                        each.price * each.quantity
                                      ).toFixed(2)}{" "}
                                    </span>{" "}
                                    <br />
                                    <span>
                                      {" "}
                                      {parseFloat(
                                        each.price * each.quantity -
                                          each.total_discount
                                      ).toFixed(2)}{" "}
                                    </span>{" "}
                                  </span>
                                ) : (
                                  parseFloat(
                                    each.price * each.quantity
                                  ).toFixed(2)
                                )}{" "}
                              </td>{" "}
                            </tr>
                          );
                        })}{" "}
                        {each.total_shipping_price_set.presentment_money
                          .amount !== "0.00" ? (
                          <tr>
                            <td colSpan="5"> </td>{" "}
                            <td colSpan="3">
                              <Row>
                                <Col
                                  md={6}
                                  style={{
                                    border: "0px solid",
                                  }}
                                >
                                  Shipping Fee:{" "}
                                </Col>{" "}
                                <Col md={6} style={table_price}>
                                  {" "}
                                  {
                                    each.total_shipping_price_set
                                      .presentment_money.amount
                                  }{" "}
                                </Col>{" "}
                              </Row>{" "}
                            </td>{" "}
                          </tr>
                        ) : null}{" "}
                        <tr>
                          <td colSpan="5"> </td>{" "}
                          <th
                            colSpan="3"
                            style={{
                              fontSize: "1.1rem",
                            }}
                          >
                            <Row>
                              <Col
                                md={6}
                                style={{
                                  border: "0px solid",
                                }}
                              >
                                Total(USD):{" "}
                              </Col>{" "}
                              <Col md={6} style={table_price}>
                                {" "}
                                {each.total_price}{" "}
                              </Col>{" "}
                            </Row>{" "}
                          </th>{" "}
                        </tr>{" "}
                      </tbody>{" "}
                    </Table>{" "}
                  </Col>{" "}
                </Row>{" "}
              </Fragment>
            );
          })}{" "}
        </Fragment>
      ) : (
        <Fragment>
          <Row
            style={{
              margin: "5rem auto",
            }}
          >
            <Col
              style={{
                textAlign: "center",
                color: "gray",
              }}
            >
              {loading ? (
                <div
                  className="d-flex mx-auto my-auto"
                  style={{
                    height: "20vh",
                  }}
                >
                  <Spinner />
                </div>
              ) : (
                <h3> No Results </h3>
              )}{" "}
            </Col>{" "}
          </Row>{" "}
        </Fragment>
      )}{" "}
    </Fragment>
  );
};

export default DisputeResultOrder;
